import { Quest } from '../../types.d'

// Re-apply families and newcomer slots AFTER client-side filters/search.
// The server supplies daily lottery values and score ordinals, not financial data.
export function rankClickQuests(quests: Quest[]): Quest[] {
  const target = quests.filter((q) => q.click_ranking)
  if (!target.length) return quests
  const ordered = target
    .slice()
    .sort(
      (a, b) => a.click_ranking!.order - b.click_ranking!.order || a.id - b.id
    )
  const winners = new Map<number, Quest>()
  ordered.forEach((q) => {
    const data = q.click_ranking!
    if (!winners.has(data.family) || data.main) winners.set(data.family, q)
  })
  const leaders = ordered.filter(
    (q) =>
      !q.click_ranking!.restricted && winners.get(q.click_ranking!.family) === q
  )
  const pool = leaders
    .filter((q) => q.click_ranking!.launched)
    .sort(
      (a, b) =>
        b.click_ranking!.launched!.localeCompare(a.click_ranking!.launched!) ||
        a.click_ranking!.family - b.click_ranking!.family
    )
    .slice(0, 10)
  const selected = pool
    .sort((a, b) => a.click_ranking!.lottery - b.click_ranking!.lottery)
    .slice(0, 3)
  const slots = target[0]
    .click_ranking!.slots.filter((i) => i < Math.min(16, leaders.length))
    .slice(0, selected.length)
    .sort((a, b) => a - b)
  const result = leaders.filter((q) => !selected.includes(q))
  slots.forEach((slot, i) => result.splice(slot, 0, selected[i]))
  result.push(
    ...ordered.filter(
      (q) => !q.click_ranking!.restricted && !leaders.includes(q)
    )
  )
  result.push(
    ...ordered
      .filter((q) => q.click_ranking!.restricted)
      .sort(
        (a, b) =>
          Number(winners.get(a.click_ranking!.family) !== a) -
            Number(winners.get(b.click_ranking!.family) !== b) ||
          a.click_ranking!.order - b.click_ranking!.order
      )
  )
  // Replace only Moscow priority-2 positions; all other groups retain their order.
  let index = 0
  return quests.map((q) => (q.click_ranking ? result[index++] : q))
}
